import React from 'react';
import {InfoMedia} from '../../components';

const CounterTwo = ({className})=> (
  <div className={`background-image ${className || ''}`} style={{backgroundImage: 'url(images/bg/counter-bg-2-1.jpg)'}}>    
    <div className="container">
      <div className="row justify-content-between gy-4">
        <div className="col-6 col-lg-auto">
          <InfoMedia className="counter-media"
            image="images/icon/count-1-1.png"
            title="10+"
            info="Projects Delivered"
          />
        </div>
        <div className="col-6 col-lg-auto">
          <InfoMedia className="counter-media"
            image="images/icon/count-1-2.png"
            title="10+"
            info="Satisfied Clients"
          />
        </div>
        <div className="col-6 col-lg-auto">
          <InfoMedia className="counter-media"
            image="images/icon/count-1-3.png"
            title="8+"
            info="Expert Developers"
          />
        </div>
        <div className="col-6 col-lg-auto">
          <InfoMedia className="counter-media"
            image="images/icon/count-1-4.png"
            title="5+"
            info="Years of Experience"
          />
        </div>
      </div>
    </div>
  </div>
);


export default CounterTwo;